import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NoteExampleComponent } from './note-example.component';
import { NoteMainModule } from '../note-main/note-main.module';
import { NoteExampleRoutingModule } from './note-example-routing.module';

import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    NoteExampleComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NoteMainModule,
    NoteExampleRoutingModule,

    // material
    MatProgressSpinnerModule,
    MatDividerModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule,
    DragDropModule,
  ],
  exports: [
    NoteExampleComponent
  ]
})
export class NoteExampleModule { }
